// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "a:not(div[role=button] a),a:not(div[role=button] a):active,a:not(div[role=button] a):hover,a:not(div[role=button] a):link,a:not(div[role=button] a):visited{font-weight:300;font-size:clamp(.90625rem,1.2vw,1.25rem);line-height:120%;letter-spacing:.3px;color:#191919;font-family:\"Montserrat\",-apple-system,sans-serif;text-decoration:none}a.link{text-decoration:none!important}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
